<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/enterpriseApplication/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="s-q-y-l-g-l page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="s-q-y-l-g-l-content">
                            <p class="text">我们以在线化、移动化、集成化、智能化的应用搭建与管理平台为业务核心，深入行业业务场景，旨在为各类企业提供一套低成本的企业应用解决方案，为客户信息化系统高效、高质量建设赋能。业务覆盖互联网、快销、银行、服装、汽车、工业制造等领域，我们愿意持续积累并更好地服务各领域的客户，让这些积累为我们的客户带来超出预期的价值。</p>
                            <auto-row class="max-size list flew-row-wrap q-y-y-y-media">
                                <auto-col class="list-item" v-for="(item,index) of q_y_y_y_list" :key="index">
                                    <div class="cell">
                                        <div class="title">{{item.title}}</div>
                                        <p class="cell-text">{{item.text}}</p>
                                        <div class="list-icons max-size flew-row-wrap">
                                            <div class="list-item-icons" v-for="(item1,index1) of item.list" :key="index1">
                                                <img :src="item1.icon" class="icons" alt="">
                                                <div class="label">{{item1.label}}</div>
                                            </div>
                                        </div>

                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>

            <div class="e-b-p page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="s-q-y-l-g-l-content">
                            <div class="title">
                                <span>EBP企业应用</span>
                                <span>开发平台</span>
                            </div>
                            <div class="e-b-p-texts">
                                <p class="text">{{e_b_p_form.content_1}}</p>
                                <p class="text">{{e_b_p_form.content_2}}</p>
                                <p class="text">{{e_b_p_form.content_3}}</p>
                            </div>
                            <auto-row class="max-size list flew-row-wrap e-b-p-media q-y-y-y-media">
                                <auto-col class="list-item" v-for="(item,index) of e_b_p_list" :key="index">
                                    <div class="cell">
                                        <img :src="item.icon" height="48" class="e-b-p-img" alt="">
                                        <div class="titles">
                                            <div class="title" v-for="(title,index1) of item.titles" :key="index1">{{title}}</div>
                                        </div>
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/enterpriseApplication/pic-1.png'),
                    // require('@/assets/image/enterpriseApplication/pic-2.png'),
                    require('@/assets/image/enterpriseApplication/pic-3.png'),
                ],
                q_y_y_y_list:[
                    {
                        title:'企业办公',
                        text:'满足企业日常核心业务管理所需，流程化，电子化，提高效率，实现随时随地无限办公。',
                        list:[
                            {label:"任务待办", icon:require('@/assets/image/enterpriseApplication/01.png')},
                            {label:"日历日程", icon:require('@/assets/image/enterpriseApplication/02.png')},
                            {label:"流程审批", icon:require('@/assets/image/enterpriseApplication/03.png')},
                            {label:"申报申请", icon:require('@/assets/image/enterpriseApplication/04.png')},
                            {label:"会议管理", icon:require('@/assets/image/enterpriseApplication/05.png')},
                            {label:"用品管理", icon:require('@/assets/image/enterpriseApplication/06.png')},
                            {label:"请假报销", icon:require('@/assets/image/enterpriseApplication/07.png')},
                        ],
                    },
                    {
                        title:'HR与员工管理',
                        text:'由数据驱动的综合人才管理战略，管理整个员工体验周期。培养满足当前和未来需求的技能，并确保每位员工都得到合理的奖励和应有的重视。',
                        list:[
                            {label:"组织岗位", icon:require('@/assets/image/enterpriseApplication/2-1.png')},
                            {label:"员工管理", icon:require('@/assets/image/enterpriseApplication/2-3.png')},
                            {label:"档案管理", icon:require('@/assets/image/enterpriseApplication/2-5.png')},
                            {label:"薪酬管理", icon:require('@/assets/image/enterpriseApplication/2-7.png')},
                            {label:"学习发展", icon:require('@/assets/image/enterpriseApplication/2-2.png')},
                            {label:"绩效考核", icon:require('@/assets/image/enterpriseApplication/2-4.png')},
                            {label:"考勤管理", icon:require('@/assets/image/enterpriseApplication/2-6.png')},
                        ],
                    },
                    {
                        title:'ERP与财务',
                        text:'帮助管理企业的方方面面，从会计和 CRM 到供应链管理和采购。灵活的计划解决方案快速构建场景模型，帮助你的企业应对各种突发状况，优化业务决策并提升绩效。',
                        list:[
                            {label:"预算管理", icon:require('@/assets/image/enterpriseApplication/3-1.png')},
                            {label:"员工报销", icon:require('@/assets/image/enterpriseApplication/3-3.png')},
                            {label:"供应商支付", icon:require('@/assets/image/enterpriseApplication/3-5.png')},
                            {label:"客户回款", icon:require('@/assets/image/enterpriseApplication/3-8.png')},
                            {label:"票据管理", icon:require('@/assets/image/enterpriseApplication/3-2.png')},
                            {label:"凭证管理", icon:require('@/assets/image/enterpriseApplication/3-4.png')},
                            {label:"资金管理", icon:require('@/assets/image/enterpriseApplication/3-6.png')},
                            {label:"报表分析", icon:require('@/assets/image/enterpriseApplication/3-7.png')},
                        ],
                    },
                    {
                        title:'CRM与客户体验',
                        text:'打造企业级客户体验，在识别、转化和留住客户的同时，抓住不断涌现的业务增长机会。交付个性化体验，实现盈利性增长，助力交付卓越的全渠道客户体验。',
                        list:[
                            {label:"商机管理", icon:require('@/assets/image/enterpriseApplication/4-1.png')},
                            {label:"客户档案", icon:require('@/assets/image/enterpriseApplication/4-3.png')},
                            {label:"价格体系", icon:require('@/assets/image/enterpriseApplication/4-5.png')},
                            {label:"合同管理", icon:require('@/assets/image/enterpriseApplication/4-8.png')},
                            {label:"订单管理", icon:require('@/assets/image/enterpriseApplication/4-2.png')},
                            {label:"发货管理", icon:require('@/assets/image/enterpriseApplication/4-4.png')},
                            {label:"客户关系", icon:require('@/assets/image/enterpriseApplication/4-6.png')},
                            {label:"电商平台", icon:require('@/assets/image/enterpriseApplication/4-7.png')},
                        ],
                    },
                    {
                        title:'数字化供应链',
                        text:'实施集成式供应链计划，协调供需计划，缩短交付周期，提高服务水平，打造韧性供应链。获取实时供应链洞察，及时发现瓶颈并降低风险。',
                        list:[
                            {label:"采购计划", icon:require('@/assets/image/enterpriseApplication/5-1.png')},
                            {label:"采购招选", icon:require('@/assets/image/enterpriseApplication/5-3.png')},
                            {label:"合同管理", icon:require('@/assets/image/enterpriseApplication/5-5.png')},
                            {label:"价格管理", icon:require('@/assets/image/enterpriseApplication/5-8.png')},
                            {label:"订单管理", icon:require('@/assets/image/enterpriseApplication/5-2.png')},
                            {label:"结算支付", icon:require('@/assets/image/enterpriseApplication/5-4.png')},
                            {label:"物料管理", icon:require('@/assets/image/enterpriseApplication/5-6.png')},
                            {label:"供应商管理", icon:require('@/assets/image/enterpriseApplication/5-7.png')},
                        ],
                    },
                    {
                        title:'固定资产管理',
                        text:'利用实时洞察、物联网，机器学习以及高级分析和预测分析工具，维护和管理实体资产的绩效，最大 度地优化资产健康状况。',
                        list:[
                            {label:"资产台账", icon:require('@/assets/image/enterpriseApplication/6-1.png')},
                            {label:"采购计划", icon:require('@/assets/image/enterpriseApplication/6-3.png')},
                            {label:"验收入库", icon:require('@/assets/image/enterpriseApplication/6-5.png')},
                            {label:"领用申请", icon:require('@/assets/image/enterpriseApplication/6-8.png')},
                            {label:"在网监控", icon:require('@/assets/image/enterpriseApplication/6-2.png')},
                            {label:"报修报废", icon:require('@/assets/image/enterpriseApplication/6-4.png')},
                            {label:"维护保障", icon:require('@/assets/image/enterpriseApplication/6-6.png')},
                            {label:"资产处置", icon:require('@/assets/image/enterpriseApplication/6-7.png')},
                        ],
                    }
                ],
                e_b_p_form:{
                    content_1:'基于JAVA语言，以成熟开源软件作为基础架构，并根据平台定制，提供多级缓存、动态负载、故障监控',
                    content_2:'底层使用自定义ORM框架，兼容各主要数据库',
                    content_3:'组件化高度可复用，快速定制开发； 业务与技术分离，专注于业务逻辑实现'
                },
                e_b_p_list:[
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP01.png'),
                        titles:['强大的组织结构库', '多维度、高扩展']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP02.png'),
                        titles:['可视化流程在线配置', '强大的审批签核功能']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP03.png'),
                        titles:['可视化在线表单设计', '快速定制企业应用']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP04.png'),
                        titles:['主流的UI框架', '操作便捷，体验舒畅']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP05.png'),
                        titles:['灵活的权限体系', '菜单、页面、数据、字段']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP06.png'),
                        titles:['完善的基础框架', '日志、字典、流程号、消息']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP07.png'),
                        titles:['开放接口', '方便集成']
                    },
                    {
                        icon:require('@/assets/image/enterpriseApplication/EBP08.png'),
                        titles:['开源，不设限', '高效二次开发']
                    }
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child{
        background-color:#FFFFFF;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


     .s-q-y-l-g-l-content{
        text-align: center;
        padding-top:130px!important;
    }

    .s-q-y-l-g-l .text{
        color:#333333;
        font-size: 24px;
        line-height: 1.6;
        transition: all .3s;
    }

    .s-q-y-l-g-l .text:hover{
        transform: translateY(-5px);
    }

    .s-q-y-l-g-l .s-q-y-l-g-l-content{
        text-align: center;
    }

    .s-q-y-l-g-l .list{
        width:calc(100% + 40px);
        text-align: center;
        margin-left: -20px;
        padding:0 10px;
    }

    .s-q-y-l-g-l .list-item{
        width:calc(50% - 80px);
        margin: 0 40px;
        margin-top:100px;
        text-align: center;
        transition: all .3s;
    }

    .s-q-y-l-g-l .list-item .cell{
        text-align: left;
    }

    .s-q-y-l-g-l .list-item .cell .title{
        font-size: 24px;
        color: #333333;
        margin-bottom:5px;
    }


    .s-q-y-l-g-l .list-item .cell .cell-text{
        line-height: 1.6;
        padding-top:10px;
        font-size: 18px;
        color:#333333;
        min-height: 100px;
        transition: all .3s;
    }

    .s-q-y-l-g-l .list-item .cell .cell-text:hover{
        transform: translateY(-5px);
    }



    .list-icons{
        width:calc(100% + 70px);
        text-align: center;
        margin-left: -35px;
    }

    .list-icons .list-item-icons{
        width:calc(25% - 70px);
        margin: 0 35px;
        margin-top:40px;
        text-align: center;
        transition: all .3s;
    }

    .list-icons .list-item-icons:hover  .icons{
        transform: rotateY(180deg);
    }

    .list-item-icons{
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        width: 100%;
    }

    .list-item-icons .icons{
        width: 62px;
        height: 62px;
        text-align:center;
        transition: .3s;
        transform: rotateY(0deg);
    }

    .list-item-icons .label{
        font-size: 18px;
        font-weight: 400;
        color: #666666;
        flex:none;
        text-align: center;
        width: 100%;
        padding-top:10px;
    }

    .q-y-y-y-media{
        display: flex;
    }

    .e-b-p .e-b-p-texts{
        margin:55px 80px 0;
        transition: all .3s;
    }

    .e-b-p .text{
        color:#333333;
        font-size: 24px;
        line-height: 1.6;
    }

    .e-b-p .e-b-p-texts:hover{
        transform: translateY(-5px);
    }

    .e-b-p-media{
        display: flex;
    }

    .e-b-p .list{
        width:calc(100% + 40px);
        text-align: center;
        margin-left: -20px;
        padding:0 10px;
    }

    .e-b-p .list-item{
        width:calc(25% - 40px);
        margin: 0 20px;
        margin-top:80px;
        text-align: center;
        transition: all .3s;
    }

    .e-b-p .list-item:hover{
        transform: translateY(-5px);
        font-weight: bold;
    }

    .e-b-p .list-item:hover .title{
        font-weight: bold;
    }

    .e-b-p .list-item .titles{
        padding:30px 0;
    }

    .e-b-p-img{
        margin-top:44px;
    }

    .e-b-p .list-item .title{;
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
    }


    .e-b-p .list-item:nth-of-type(1){
        background-image: url('~@/assets/image/enterpriseApplication/bg-01.png');
        background-position: right bottom;
    }
    .e-b-p .list-item:nth-of-type(2){
        background-image: url('~@/assets/image/enterpriseApplication/bg-02.png');
        background-position: left bottom;
    }
    .e-b-p .list-item:nth-of-type(3){
        background-image: url('~@/assets/image/enterpriseApplication/bg-03.png');
        background-position: right top;
    }
    .e-b-p .list-item:nth-of-type(4){
        background-image: url('~@/assets/image/enterpriseApplication/bg-04.png');
        background-position: left top;
    }

    .e-b-p .list-item:nth-of-type(5){
        background-image: url('~@/assets/image/enterpriseApplication/bg-05.png');
        background-position: right bottom;
    }
    .e-b-p .list-item:nth-of-type(6){
        background-image: url('~@/assets/image/enterpriseApplication/bg-06.png');
        background-position: left bottom;
    }
    .e-b-p .list-item:nth-of-type(7){
        background-image: url('~@/assets/image/enterpriseApplication/bg-07.png');
        background-position: right top;
    }
    .e-b-p .list-item:nth-of-type(8){
        background-image: url('~@/assets/image/enterpriseApplication/bg-08.png');
        background-position: left top;
    }





    /*适配不同尺寸*/
    @media screen and (max-width: 1300px){
        .list-icons{
            width:calc(100% + 60px);
            text-align: center;
            margin-left: -30px;
        }

        .list-icons .list-item-icons{
            width:calc(25% - 60px);
            margin: 0 30px;
            margin-top:40px;
            text-align: center;
            transition: all .3s;
        }
    }

    @media screen and (max-width: 1200px){
        .list-icons{
            width:calc(100% + 10px);
            text-align: center;
            margin-left: -5px;
        }

        .list-icons .list-item-icons{
            width:calc(25% - 10px);
            margin: 0 5px;
            margin-top:40px;
            text-align: center;
            transition: all .3s;
        }

        .e-b-p .list{
            width:calc(100% + 40px);
            text-align: center;
            margin-left: -20px;
            padding:0 10px;
        }

        .e-b-p .list-item{
            width:calc(33.33% - 40px);
            margin: 0 20px;
            margin-top:70px;
            text-align: center;
            transition: all .3s;
        }
    }

    @media screen and (max-width: 960px){
        .q-y-y-y-media{
            display: flex;
            flex-flow: column nowrap!important;
            align-items:flex-start!important;
        }

        .s-q-y-l-g-l .list{
            width:calc(100% + 40px);
            text-align: center;
            margin-left: -20px;
            padding:0 10px;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(100% - 80px);
            margin: 0 40px;
            margin-top:80px;
            text-align: center;
            transition: all .3s;
        }

        .list-icons{
            width:calc(100% + 70px);
            text-align: center;
            margin-left: -35px;
        }

        .list-icons .list-item-icons{
            width:calc(25% - 70px);
            margin: 0 35px;
            margin-top:40px;
            text-align: center;
            transition: all .3s;
        }


        .e-b-p .e-b-p-texts{
            margin:30px 15px 0;
        }

        .e-b-p-media{
            display: flex;
            flex-flow: row wrap!important;
        }

        .e-b-p .list{
            width:calc(100% + 40px);
            text-align: center;
            margin-left: -20px;
            padding:0 10px;
        }

        .e-b-p .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:60px;
            text-align: center;
            transition: all .3s;
        }
        .e-b-p .list-item .titles{
            padding:25px 0;
        }

        .e-b-p-img{
            margin-top:30px;
        }

    }

    @media screen and (max-width: 760px){
        .e-b-p .e-b-p-texts{
            margin:25px 10px 0;
        }
        .e-b-p-media{
            display: flex;
            flex-flow: row wrap!important;
        }

        .e-b-p .list{
            width:calc(100% + 40px);
            text-align: center;
            margin-left: -20px;
            padding:0 10px;
        }

        .e-b-p .list-item{
            width:calc(100% - 40px);
            margin: 0 20px;
            margin-top:40px;
            text-align: center;
            transition: all .3s;
        }
        .e-b-p .list-item .titles{
            padding:20px 0;
        }

        .e-b-p-img{
            margin-top:24px;
        }
    }
</style>
